import { render, staticRenderFns } from "./swiperBrandme.vue?vue&type=template&id=65b859ed&scoped=true&"
import script from "./swiperBrandme.vue?vue&type=script&lang=js&"
export * from "./swiperBrandme.vue?vue&type=script&lang=js&"
import style0 from "./swiperBrandme.vue?vue&type=style&index=0&lang=css&"
import style1 from "./swiperBrandme.vue?vue&type=style&index=1&id=65b859ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b859ed",
  null
  
)

export default component.exports